<template>
    <div class="container-fluid">
        <div class="page-title">
            <h4>Ajouter un groupe d'utilisateurs</h4>

        </div>
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-block">
                        <div class="col-md-10 ml-auto mr-auto">
                            <form @submit.prevent="add">
                                <div class="row">
                                    <div class="col-md-12">
                                        <div class="form-group">
                                            <label>Nom du groupe</label>
                                            <input v-model="name" 
                                                    type="text" name="Nom du groupe" 
                                                    @keypress="check_input($event)"
                                                    
                                                    placeholder="Entrer le nom du groupe" 
                                                    class="form-control" 
                                                    minlength="1" 
                                                    maxlength="45" 
                                                    required >
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-12">
                                        <div class="form-group">
                                            <label>Commentaire</label>
                                            <input v-model="comment"
                                                    type="text"
                                                    name="Commentaire" 
                                                    @keypress="check_input($event)"
                                                    
                                                    placeholder="Saisir un commentaire"
                                                    class="form-control" 
                                                    minlength="0" 
                                                    maxlength="128">
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-12">
                                        <div class="form-group">
                                            <label>Sélectionnez le responsable de ce groupe</label>
                                            <select id="responsableSelection" class="form-control" v-model="responsible" required>
                                                <option disabled value="null">Choisissez un responsable</option>
                                                <option v-for="adherent in adherents" v-bind:value="adherent.id" v-bind:key="adherent.id">
                                                    {{adherent.title}} {{adherent.lastname}} {{adherent.firstname}} 
                                                </option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                                <div class="text-right mrg-top-5">
                                    <button type="button" class="btn btn-default button-previous btn-rounded" @click="clear()">Annuler</button>
                                    <button type="submit" class="btn btn-primary">Créer</button>
                                </div>
                                <div class="alert alert-danger" role="alert" v-if="error">
                                            Impossible d'ajouter de groupe ! Veuillez contacter KEMTAG
                                     <i class="ti-close float-right mt-1" @click="error = false"></i>
                                </div> 
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import api from "../../config/_api";
    import { mapGetters } from 'vuex';
//    import { mapMutations } from 'vuex';
//    import adherents from "../../store/modules/adherents";

    export default {
        name: "Add",
        data () {
            return {
                name: "",
                comment: "",
                responsible: null,
                error: false // initialiser l'objet error {pour la fonction alerte}
            }
        },
        computed: {
            ...mapGetters({
                adherents: 'adherents/adherents',
                structure: 'structure/structure',
            }),
        },
        mounted() {
            this.$store.dispatch('adherents/getUtilisateurs');
            this.$store.dispatch('structure/getStructure');
        },
        methods: {

             clear() {
                  this.comment = null,
                 this.name = null,
                 this.responsible= null,
                  this.$router.push("/usergroup/index");
              
              
            },
            add() {
                let data = {
                    comment: this.comment,
                    name: this.name,
                    status: 1,
                    responsible_id: this.responsible,
                };
                    
                this.axios({url: api.url + 'user_groups?structure_id=' + this.$store.getters.structure_id, data: data, method: 'POST' })
                .then(resp => {        
                    if(resp.status <400){                        
                        this.$router.push("/usergroup/index");
                    }
                })
                .catch(err => {          
                    this.error = true;  
                    //console.log(err + "\t err");                                
                });

            },
            check_input: function(event){
                if( event.keyCode < 8 ||  event.keyCode > 122 || event.keyCode==13 || event.keyCode==33 || event.keyCode==34 || event.keyCode==35 || event.keyCode==36 || event.keyCode==37 || event.keyCode==38 || event.keyCode==39 || event.keyCode==40 || event.keyCode==41 || event.keyCode==42 || event.keyCode==43 || event.keyCode==44 || event.keyCode==46 || event.keyCode==47 || event.keyCode==58 || event.keyCode==59 || event.keyCode==60 || event.keyCode==61 || event.keyCode==62 || event.keyCode==63 || event.keyCode==64 || event.keyCode==91 || event.keyCode==92 || event.keyCode==93 || event.keyCode==94 || event.keyCode==96) event.returnValue = false;
                if( event.which < 8 ||  event.which > 122  || event.which==13 || event.which==33 || event.which==34 || event.which==35 || event.which==36 || event.which==37 || event.which==38 || event.which==39 || event.which==40 || event.which==41 || event.which==42 || event.which==43 || event.which==44|| event.which==46 ||  event.which==47 ||  event.which==58 ||  event.which==59 ||  event.which==60 ||  event.which==61 ||  event.which==62 ||  event.which==63 ||  event.which==64 ||  event.which==91 ||  event.which==92 ||  event.which==93 ||  event.which==94 ||  event.which==96) return false;
            }
        }
    }
</script>

<style scoped>

</style>